import { useState } from 'react';
import { Paper, Button, ClickAwayListener, TextField } from '@mui/material';
import { Iconic } from '@/commons/iconic';
import { translates } from '@/utils';

export default function KanbanColumnAdd({ setBoard }: any) {
  // const dispatch = useDispatch();

  const [name, setName] = useState('');

  const [open, setOpen] = useState(false);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleChangeName = (event: React.ChangeEvent<HTMLInputElement>) => {
    setName(event.target.value);
  };

  const handleCreateColumn = async () => {
    try {
      if (name) {
        const newId = crypto.randomUUID();
        setBoard((prev: any) => ({
          ...prev,
          columns: {
            ...prev.columns,
            [newId]: {
              id: newId,
              name,
              cardIds: [],
            },
          },
          columnOrder: [...prev.columnOrder, newId],
        }));
        setName('');
      }
      handleClose();
    } catch (error) {
      console.error(error);
    }
  };

  const handleKeyUp = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter') {
      handleCreateColumn();
    }
  };

  return (
    <Paper sx={{ minWidth: 280, width: 280 }}>
      {open ? (
        <ClickAwayListener onClickAway={handleCreateColumn}>
          <TextField
            autoFocus
            fullWidth
            placeholder="New section"
            value={name}
            onChange={handleChangeName}
            onKeyUp={handleKeyUp}
            InputProps={{
              sx: { typography: 'h6' },
            }}
          />
        </ClickAwayListener>
      ) : (
        <Button
          fullWidth
          size="large"
          color="inherit"
          variant="outlined"
          startIcon={<Iconic icon="eva:plus-fill" />}
          onClick={handleOpen}
        >
          {translates.addSection}
        </Button>
      )}
    </Paper>
  );
}
